import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router";
import { AuthContext } from "./Auth";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const context = useContext(AuthContext);
  const location = useLocation();

  if (!context?.currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;
